// src/Pages/Terminos.jsx
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export default function Terminos() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      try {
        const ref = doc(db, "config", "terminos");
        const snap = await getDoc(ref);
        if (snap.exists()) setData(snap.data());
      } catch (e) {
        console.error("Error cargando términos:", e);
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  if (loading || !data) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100 px-4">
        <p className="text-slate-500 text-sm">
          Cargando términos y condiciones...
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">

        {/* Encabezado institucional / breadcrumb */}
        <div className="mb-6 text-[11px] uppercase tracking-[0.18em] text-slate-500 flex flex-col sm:flex-row sm:justify-between gap-1 sm:gap-0">
          <span>EKINE · DOCUMENTO LEGAL</span>
          <span className="text-right">TÉRMINOS Y CONDICIONES</span>
        </div>

        {/* Contenedor principal */}
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm">

          {/* HEADER DEL DOCUMENTO */}
          <div className="border-b border-slate-200 px-5 sm:px-8 py-6">
            <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-[#00698F] leading-tight">
              Términos y Condiciones de Servicio
            </h1>

            <p className="mt-3 text-sm sm:text-base text-slate-600 max-w-3xl leading-relaxed">
              El presente documento establece las condiciones bajo las cuales se prestan los
              servicios de kinesiología, masoterapia, recuperación y planes de entrenamiento
              ofrecidos por Ekine.
            </p>
          </div>

          {/* CUERPO PRINCIPAL */}
          <div className="px-5 sm:px-8 py-8 space-y-8 sm:space-y-10 font-sans text-[14px] sm:text-[15px] leading-relaxed text-slate-700">

            {/* Sección 1 */}
            <section>
              <h2 className="text-lg sm:text-xl font-bold tracking-tight text-[#0A1440] mb-3 flex items-baseline gap-2">
                <span className="text-xs font-bold text-[#0B5C6B]">1.</span>
                <span>{data.titulo_kine}</span>
              </h2>

              <p className="whitespace-pre-line text-justify">
                {data.cuerpo_kine}
              </p>
            </section>

            <hr className="border-dashed border-slate-200" />

            {/* Sección 2 */}
            <section>
              <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-3 flex items-baseline gap-2">
                <span className="text-xs font-bold text-slate-500">2.</span>
                <span>{data.titulo_planes}</span>
              </h2>

              <p className="whitespace-pre-line text-justify">
                {data.cuerpo_planes}
              </p>
            </section>

            {/* Sección Confidencialidad (dinámica) */}
            {(data.titulo_confidencialidad || data.cuerpo_confidencialidad) && (
              <>
                <hr className="border-dashed border-slate-200" />

                <section>
                  <h2 className="text-lg sm:text-xl font-bold tracking-tight text-[#0A1440] mb-3 flex items-baseline gap-2">
                    <span className="text-xs font-bold text-[#0B5C6B]">3.</span>
                    <span>{data.titulo_confidencialidad}</span>
                  </h2>

                  <p className="whitespace-pre-line text-justify">
                    {data.cuerpo_confidencialidad}
                  </p>
                </section>
              </>
            )}

            {/* Nota general */}
            {data.nota_general && (
              <>
                <hr className="border-dashed border-slate-200" />

                <section>
                  <h3 className="text-base sm:text-lg font-bold tracking-tight text-[#0A1440] mb-2 flex items-baseline gap-2">
                    <span className="text-xs font-bold text-[#0B5C6B]">
                      {(data.titulo_confidencialidad || data.cuerpo_confidencialidad) ? "4." : "3."}
                    </span>
                    <span>DISPOSICIONES GENERALES</span>
                  </h3>

                  <p className="whitespace-pre-line text-justify text-slate-700 italic">
                    {data.nota_general}
                  </p>
                </section>
              </>
            )}
          </div>

          {/* PIE DEL DOCUMENTO */}
          <div className="px-5 sm:px-8 py-4 border-t border-slate-200 bg-slate-50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
            <p className="text-[11px] sm:text-[12px] text-slate-500 leading-snug">
              La confirmación de una reserva implica la lectura y aceptación de
              los presentes Términos y Condiciones.
            </p>

            {data.ultima_actualizacion && (
              <p className="text-[11px] sm:text-[12px] text-slate-500 leading-snug">
                Última actualización:{" "}
                <span className="font-medium">
                  {data.ultima_actualizacion}
                </span>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
